import React, { useState } from "react";
import { DownloadSimple, EnvelopeSimple, Warning } from "@phosphor-icons/react";
import { toast } from "sonner";
import api from "@/lib/api";
import { EmailSpecDialog } from "./LeadShareEmail";

const KINDS = [
  { kind: "json", label: "Sample file (JSON)" },
  { kind: "csv", label: "Field list (CSV)" },
  { kind: "pdf", label: "Spec sheet (PDF)" },
];

const blobError = async (e) => {
  try {
    return JSON.parse(await e.response.data.text()).detail;
  } catch {
    return "Couldn't build the download";
  }
};

// Files for the buyer's tech team, built from exactly what the preview shows.
export function SampleDownload({ body, destId }) {
  const [source, setSource] = useState("sample");
  const [busy, setBusy] = useState(null);
  const [emailing, setEmailing] = useState(false);
  const download = async (kind) => {
    setBusy(kind);
    try {
      const r = await api.post("/admin/lead-share/sample-download", { ...body, dest_id: destId, source, kind }, { responseType: "blob" });
      const m = (r.headers?.["content-disposition"] || "").match(/filename="([^"]+)"/);
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = m ? m[1] : `sample-lead.${kind}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
      toast.success("Downloaded");
    } catch (e) {
      toast.error(await blobError(e));
    } finally {
      setBusy(null);
    }
  };
  return (
    <div className="border-t-2 border-black bg-yellow-50 px-3 py-2" data-testid="lead-share-download">
      <div className="mb-1 flex items-center gap-1 text-[11px] font-bold uppercase tracking-widest">
        <DownloadSimple size={12} weight="bold" /> Download for their tech team
      </div>
      <select value={source} onChange={(e) => setSource(e.target.value)} className="mb-2 w-full border-2 border-black bg-white px-2 py-1 text-[12px]"
              data-testid="lead-share-download-source">
        <option value="sample">Made-up sample lead</option>
        <option value="real">{destId ? "Most recent real lead sent to them" : "Most recent real lead"}</option>
      </select>
      {source === "real" && (
        <p className="mb-2 flex gap-1 text-[10px] text-red-700" data-testid="lead-share-download-real-warning">
          <Warning size={12} className="shrink-0" weight="bold" /> Contains a real person&apos;s details — share it only with this buyer.
        </p>
      )}
      <div className="grid gap-1.5">
        {KINDS.map((k) => (
          <button key={k.kind} type="button" onClick={() => download(k.kind)} disabled={Boolean(busy)} data-testid={`lead-share-download-${k.kind}`}
                  className="border-2 border-black bg-white px-2 py-1 text-left text-[11px] font-bold transition-colors duration-100 hover:bg-black hover:text-white disabled:opacity-50">
            {busy === k.kind ? "Building…" : k.label}
          </button>
        ))}
        {destId && (
          <button type="button" onClick={() => setEmailing(true)} data-testid="lead-share-email-open"
                  className="inline-flex items-center gap-1.5 border-2 border-black bg-black px-2 py-1 text-left text-[11px] font-bold text-white transition-colors duration-100 hover:bg-emerald-700">
            <EnvelopeSimple size={12} weight="bold" /> Email to their tech team
          </button>
        )}
      </div>
      {emailing && <EmailSpecDialog body={body} destId={destId} onClose={() => setEmailing(false)} />}
    </div>
  );
}
